import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;

const EncounterXrayService = {
    apply: async (payload) => axios.post(API_URL + "/encounter_x_ray/apply", payload).then(({ data }) => data).catch((err) => { throw err }),
}

export default EncounterXrayService;